const KEY_WIDTH = 40
const INDENT_AMOUNT = 3

export default function WriteInfile (data, keyOrder) {
  data = orderKeys(data, keyOrder)
  return write(data) + '\n'
}

function write (data, indent, isRun) {
  if (typeof data !== 'object') throw new Error(`infile writer expects an object: ${data}`)
  const result = []
  indent = indent || 0

  Object.keys(data).forEach((key) => {
    const pairIndent = isRun
      ? KEY_WIDTH - key.length - indent - 1
      : KEY_WIDTH - key.length

    const value = data[key]

    // multi_line strings need special handling
    if (isMultiLine(value)) {
      const v = isMultiLine(value) ? value[0] : value
      result.push(...writeMultiline(key, v, pairIndent))
      return result
    }

    if (isPair(value)) {
      // run sections take into account for existing indentation
      // when indenting key values, regular sections do not.

      result.push(...writePair(key, value, pairIndent))
    }
    if (isSection(value)) {
      result.push(...writeSection(key, value, indent))
    }
  })

  return result
    .map((line) => indentValue(indent, line))
    .map((line) => {
    // lines with only spaces are empty
      if (line.trim().length === 0) return ''
      return line
    }).join('\n')
}

function writeSection (key, value) {
  const isRunSection = (key.indexOf('Run') === 0)

  const result = []
  result.push('')
  result.push(`BeginSection ${key}`)
  // only write section body if there is
  // something to write.
  if (Object.keys(value).length) {
    result.push(
      ...write(
        value,
        INDENT_AMOUNT,
        isRunSection
      ).split('\n')
    )
  }

  if (isRunSection) {
    // end of run sections
    // has empty line and
    result.push('')
    result.push('EndSection')
  } else {
    // end of non-run sections
    // has a single trailing space
    result.push('EndSection ')
  }

  return result
}

function writeMultiline (key, value, indent) {
  return ['', key + indentValue(indent, '__start_multi_string__')] // add header
    .concat(value.split(/[\r\n]/), '') // get additional lines
    .concat(key + indentValue(indent, '__end_multi_string__')) // add footer
}

function writePair (key, value, indent) {
  const result = []
  result.push(key + indentValue(indent, value))
  return result
}

function indentValue (num, str) {
  if (num < 0) throw new Error(`invalid indent ${num}. ${str}`)
  if (str == null) str = ''
  num = num || 0
  str = String(str) || ''
  return (new Array(num + 1).join(' ')) + str
}

function isPair (value) {
  return !isSection(value)
}

function isMultiLine (value) {
  return Array.isArray(value)
}

function isSection (value) {
  return String(value) === '[object Object]' && !isMultiLine(value)
}

const DEFAULT_ORDER = [
  'executable',
  'xml_file',
  'parms_file',
  'verbosity_level',
  'overwrite_data_files',
  'make_log_files',
  'data_directory',
  'working_directory',
  'Output_Data_File',
  'MPI',
  'python_logging_level',
  'compression'
]

function orderKeys (data, keyOrder = DEFAULT_ORDER) {
  const orderedKeys = []
  const runSections = []
  const preorderedKeys = []
  Object.keys(data).forEach(key => {
    if (keyOrder.includes(key)) {
      orderedKeys.push(key)
    } else if (key.startsWith('Run_')) {
      runSections.push(key)
    } else {
      preorderedKeys.push(key)
    }
  })

  // sort keys by order param
  orderedKeys.sort((a, b) => keyOrder.indexOf(a) - keyOrder.indexOf(b))

  // add preordered keys
  orderedKeys.push(...preorderedKeys)

  // sort run sections by Run_X index
  runSections.sort((a, b) => getRunIndex(a) - getRunIndex(b))
  orderedKeys.push(...runSections) // add runsections last

  return orderedKeys.reduce((orderedData, key) => {
    orderedData[key] = data[key]
    return orderedData
  }, {})
}

function getRunIndex (key) {
  return Number.parseInt(key.split('Run_')[1])
}



// WEBPACK FOOTER //
// ../webmango-core/infile.js